import { memo } from 'react';
import { useSelector } from 'react-redux';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import UISmall from 'UIComponents/elements/Small';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { convertDateRangeToPresetId } from '../../util/DateRangeConverter';
import { jsx as _jsx } from "react/jsx-runtime";
const FILTERS_LIMIT_COUNT = 7;
function getDateRangeDisplay(dateRange) {
  return dateRange.isEmpty() ? [] : [I18n.text(`app.filter.panel.dateRange.options.${convertDateRangeToPresetId(dateRange)}`)];
}
function getLanguagesDisplay(languages) {
  return languages.map(language => I18n.text(`app.filter.panel.language.options.${language}`));
}
function getProductAreasDisplay(productAreas, productAreasById) {
  return productAreas.map(productArea => productAreasById.get(productArea).name);
}
function getTicketOwnersDisplay(ticketOwners, ticketOwnersByEmail) {
  return ticketOwners.map(ticketOwner => ticketOwnersByEmail.get(ticketOwner)).map(ticketOwner => ticketOwner.isCurrentUser ? I18n.text('app.filter.panel.ticketOwner.currentUser', {
    name: ticketOwner.name
  }) : ticketOwner.name);
}
function FiltersAppliedText() {
  const filters = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filters);
  const filterOptions = useSelector(
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'zorseTicketInspector' does not exist on ... Remove this comment to see the full error message
  ({
    zorseTicketInspector
  }) => zorseTicketInspector.filterOptions);
  let filterNames = [...getDateRangeDisplay(filters.dateRange), ...getLanguagesDisplay(filters.languages), ...getProductAreasDisplay(filters.productAreas, filterOptions.productAreasById), ...getTicketOwnersDisplay(filters.ticketOwners, filterOptions.ticketOwnersByEmail)];
  const overLimitFiltersCount = Math.max(0, filterNames.length - FILTERS_LIMIT_COUNT);
  filterNames = filterNames.slice(0, FILTERS_LIMIT_COUNT);
  if (overLimitFiltersCount > 0) {
    filterNames.push(I18n.text('app.common.moreFilters', {
      count: overLimitFiltersCount
    }));
  }
  return /*#__PURE__*/_jsx(UITooltip, {
    placement: "bottom left",
    title: filterNames.join(', '),
    children: /*#__PURE__*/_jsx(UISmall, {
      use: "help",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        "data-test-id": "filters-applied-text-internal",
        message: "app.common.filtersApplied",
        options: {
          count: filters.count()
        }
      })
    })
  });
}
export default /*#__PURE__*/memo(FiltersAppliedText);